<div class="w-100 d-flex justify-content-between nft-modal__header">
  <div class="d-flex align-items-center">{{ header }}</div>
</div>
